import { SaveTipoRiesgo } from "../../components";

export default function CreateTipoRiesgoPage() {
  return <SaveTipoRiesgo titulo="Crear tipo de riesgo" />;
}
